import fetchWiremock from 'utilities/mock/fetchWiremock';
import { BasketAddItemOptions, BasketAmendItemOptions, BasketResponse } from 'types/BasketTypes';
import eventBus from '@sd-utility/eventbus';
import { waitForODMReady } from 'utilities/basket/basketUtilities';
import { MockDirectives } from 'types/Mock';
import { getMockScenarioForProvider } from 'utilities/mock/mockingUtilities';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import adaptBasketResponse from '../adaptors/adaptBasketResponse';

export default class MockBasketService implements BasketServiceInterface {
  private static initialized = false;

  constructor(mockDirectives?: MockDirectives) {
    this.simulateODMInitialization(mockDirectives);
  }

  async addItem({ item }: BasketAddItemOptions): Promise<BasketResponse> {
    await this.waitForMockReady();

    const response = await fetchWiremock({
      method: 'POST',
      path: '/api/checkout/v1/basket/items',
      body: item,
    });

    const data = (await response.json()) as BasketResponse;

    return adaptBasketResponse({
      ...data,
      ok: response.ok,
      status: response.status,
    });
  }

  async amendItem({ lineItem, item }: BasketAmendItemOptions): Promise<BasketResponse> {
    await this.waitForMockReady();

    const response = await fetchWiremock({
      method: 'PUT',
      path: `/api/checkout/v1/basket/items/${lineItem}`,
      body: item,
    });

    const data = (await response.json()) as BasketResponse;

    return adaptBasketResponse({
      ...data,
      ok: response.ok,
      status: response.status,
    });
  }

  private simulateODMInitialization(mockDirectives?: MockDirectives): void {
    const mockScenario = mockDirectives ? getMockScenarioForProvider(mockDirectives, 'odm-basket-init') : undefined;

    let simulateDelay = false;
    let delayInitMs = 0;

    if (mockScenario) {
      switch (mockScenario) {
        case 'fast':
          simulateDelay = true;
          delayInitMs = 500;
          break;
        case 'slow':
          simulateDelay = true;
          delayInitMs = 4000;
          break;
        case 'timeout':
          simulateDelay = true;
          delayInitMs = 10000;
          break;
        case 'failure':
          simulateDelay = true;
          delayInitMs = 400;
          break;
        default:
          simulateDelay = false;
          break;
      }
    }

    if (simulateDelay) {
      setTimeout(() => {
        if (mockScenario === 'failure') {
          MockBasketService.initialized = false;
          eventBus.publish('odm/client-ready', {
            initialized: false,
            error: 'Mock ODM initialization failed',
          });
        } else {
          MockBasketService.initialized = true;
          eventBus.publish('odm/client-ready', {
            initialized: true,
            initResult: 'mock-initialization-complete',
          });
        }
      }, delayInitMs);
    } else {
      MockBasketService.initialized = true;
    }
  }

  private async waitForMockReady(): Promise<void> {
    if (MockBasketService.initialized) return;
    await waitForODMReady('mock', undefined);
  }
}
